export default {
  data () {
    return {
      sortData: {
        currentSort:'',
        currentSortDir: '',
        counter: 0,
        loaded: false
      },
    }
  },

  computed: {
    sorterArrow: function () {
      if (this.sortData.counter % 3 === 1){
        return 'data:image/gif;base64,R0lGODlhFQAEAIAAAP///////yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7'
      }
      else if (this.sortData.counter % 3 ===2){
        return 'data:image/gif;base64,R0lGODlhFQAEAIAAAP///////yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7'
      }
    }
  },

  methods: {
    sort(value, type) {
      this.sortData.type = type || 0;
      if (this.sortData.currentSort !== value){
        this.sortData.counter = 0
      }
      this.sortData.counter++
      this.sortData.currentSort = value

      if (this.sortData.counter % 3 === 1){
        this.sortData.currentSortDir = 'asc'
      }
      else if(this.sortData.counter % 3 === 2) {
        this.sortData.currentSortDir = 'desc'
      }
    }
  }
}
